import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { Field, FieldBody, ValidationMessage } from 'web-ui-components/lib/molecules/forms';
import { Prefix, Input } from 'web-ui-components/lib/atoms/forms';
import { stripIllegalCharacters, amountWithinLimit } from '../../businessLogic/AccountsBL';
import { getBalanceRequestPacket } from '../../utils/RequestPacketBuilder';
import { TogglePanel } from 'web-ui-components/lib/molecules/panels';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { isEmpty } from 'lodash';
import { NavigationButton, NavigationButtonGroup } from 'web-ui-components/lib/navigation/buttons';
import { FIX_DECIMAL_BY_TWO } from '../../constants/StringConstants';
import { fixAmount } from '../../utils/NumberUtils';
import { isButtonDisabled } from '../../businessLogic/AlertsBL';

class MultipleAlert extends Component {
  constructor(props) {
    super(props);
    this.handleAmountChange = this.handleAmountChange.bind(this);
    this.handleAlertCheck = this.handleAlertCheck.bind(this);
    this.confirmAlertChange = this.confirmAlertChange.bind(this);
    this.cancelAlertChanges = this.cancelAlertChanges.bind(this);
    this.toggleOptionFactory = this.toggleOptionFactory.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    const {
      alertPacket: {
        amount: { value: alertAmount },
      },
    } = props;
    this.state = {
      amount: alertAmount.toFixed(FIX_DECIMAL_BY_TWO),
      isButtonDisabled: false,
    };
  }
  componentWillUnmount() {
    const { showAlertsError, alertID } = this.props;
    showAlertsError(false, alertID);
  }
  handleAmountChange(event) {
    const { alertID, showAlertsError, alertPacket, editModeEnabled } = this.props;
    const amount = stripIllegalCharacters(event.target.value);
    if (amount) {
      editModeEnabled(true);
    }
    this.setState({ isButtonDisabled: isButtonDisabled(amount, alertPacket.amount.value) });
    showAlertsError(isEmpty(amount), alertID);
    if (amountWithinLimit(amount)) {
      this.setState({ amount });
    }
  }
  handleOnBlur(event) {
    const {
      alertPacket: {
        amount: { value: alertAmount },
      },
    } = this.props;
    const amount = fixAmount(event.target.value);
    this.setState({ amount: amount, isButtonDisabled: isButtonDisabled(amount, alertAmount) });
  }
  handleAlertCheck() {
    const { alertID, handleBalanceRequestPacket, isAlertActive, alertPacket, isLoading } =
      this.props;
    const amount = alertPacket.amount.value;
    const highBalRequestPacket = getBalanceRequestPacket(!isAlertActive, amount, alertID);
    handleBalanceRequestPacket(highBalRequestPacket, alertID);
    this.setState({ amount: amount.toFixed(FIX_DECIMAL_BY_TWO), isButtonDisabled: isLoading });
  }
  confirmAlertChange() {
    const { amount } = this.state;
    const { alertID, handleBalanceRequestPacket, isLoading, editModeEnabled } = this.props;
    const highBalRequestPacket = getBalanceRequestPacket(true, amount, alertID);
    handleBalanceRequestPacket(highBalRequestPacket, alertID);
    this.setState({ isButtonDisabled: isLoading });
    editModeEnabled(false);
  }
  cancelAlertChanges() {
    const { alertPacket, editModeEnabled } = this.props;
    this.setState({
      isButtonDisabled: false,
      amount: alertPacket.amount.value.toFixed(FIX_DECIMAL_BY_TWO),
    });
    editModeEnabled(false);
  }
  toggleOptionFactory() {
    const { title, isAlertActive, alertInfoText } = this.props;
    const displayIcon = (
      <Icon iconType="GenericMoneyOutlineLarge" className="c-a-button__icon" direction="right" />
    );
    return (
      <ToggleOption
        icon={displayIcon}
        title={title}
        blurb={alertInfoText}
        active={isAlertActive}
        onChange={this.handleAlertCheck}
      />
    );
  }
  render() {
    const { amount, isButtonDisabled } = this.state;
    const { isLoading, content, isAlertActive, alertValidationMsg } = this.props;
    const isButtonEnable = isButtonDisabled && !alertValidationMsg;
    return (
      <Card bordered="unbranded" className="u-padding-top-1 u-padding-bottom-1">
        <TogglePanel
          toggleOptionFactory={this.toggleOptionFactory}
          active={isAlertActive}
          onChange={this.handleAlertCheck}
        >
          {isAlertActive && (
            <div className="u-padding-top-2">
              <Field>
                <FieldBody>
                  <Prefix>{content.poundSign}</Prefix>
                  <Input
                    type="text"
                    value={amount}
                    onChange={this.handleAmountChange}
                    onBlur={this.handleOnBlur}
                    hasPrefix
                  />
                </FieldBody>
              </Field>
              {alertValidationMsg && (
                <ValidationMessage
                  value={content.alertValidationMsg}
                  iconType="ExclamationCircleLarge"
                />
              )}
            </div>
          )}
          {isButtonEnable && (
            <NavigationButtonGroup
              primaryButton={
                <NavigationButton.Primary
                  labelText={content.confirmText}
                  onClick={this.confirmAlertChange}
                  isLoading={isLoading}
                />
              }
              secondaryButtons={
                <NavigationButton.Secondary
                  labelText={content.cancelText}
                  onClick={this.cancelAlertChanges}
                />
              }
            />
          )}
        </TogglePanel>
      </Card>
    );
  }
}

MultipleAlert.propTypes = {
  alertID: PropTypes.string,
  isLoading: PropTypes.bool,
  isAlertActive: PropTypes.bool,
  content: PropTypes.shape({}),
  title: PropTypes.string,
  alertInfoText: PropTypes.string,
  handleBalanceRequestPacket: PropTypes.func,
  alertPacket: PropTypes.shape({
    amount: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  showAlertsError: PropTypes.func,
  alertValidationMsg: PropTypes.bool,
  editModeEnabled: PropTypes.func,
};

export default MultipleAlert;
